// Session de l'app côté navigateur, lue dans le publicMetadata Clerk de
// l'utilisateur (même source que les claims JWT vérifiés par l'API, cf.
// api/src/lib/access.ts). Ne protège que l'affichage : l'autorisation réelle
// se joue dans les gardes de l'API.

import { useUser } from "@clerk/clerk-react";

export const COMPTA_TEAM = "compta";

export interface AppSession {
  isSuperAdmin: boolean;
  /** superAdmin ou membre de la team compta : accès à l'app. */
  canAccessCompta: boolean;
}

interface PublicMetadata {
  role?: string | null;
  teams?: unknown;
  isSuperAdmin?: boolean | null;
}

export function sessionFromMetadata(meta: PublicMetadata | null | undefined): AppSession {
  const teams = Array.isArray(meta?.teams) ? meta.teams.filter((t): t is string => typeof t === "string") : [];
  const isSuperAdmin = meta?.role === "ADMIN" && meta.isSuperAdmin === true;
  return { isSuperAdmin, canAccessCompta: isSuperAdmin || teams.includes(COMPTA_TEAM) };
}

export function useAppSession(): AppSession {
  const { user } = useUser();
  return sessionFromMetadata(user?.publicMetadata as PublicMetadata | undefined);
}
